import { render, staticRenderFns } from "./CallbackComponent.vue?vue&type=template&id=4c0ce540&scoped=true"
import script from "./CallbackComponent.vue?vue&type=script&lang=js"
export * from "./CallbackComponent.vue?vue&type=script&lang=js"
import style0 from "./CallbackComponent.vue?vue&type=style&index=0&id=4c0ce540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0ce540",
  null
  
)

export default component.exports